import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sales-filters"
export default class extends Controller {
  static values = { url: String }

  connect() {
  }

  static get targets() {
    return ["status", "list", "rate", "verified"]
  }

  submit() {
    const checkedValue = this.verifiedTarget.value
    const rateValue = this.rateTarget.value
    const statusValue = this.statusTarget.value

    this.listTarget.innerHTML = 'loading';

    fetch(`${this.urlValue}.json?checked=${checkedValue}&rate=${rateValue}&status=${statusValue}`, {
      contentType: 'application/json',
      hearders: 'application/json'
    })
    .then((response) => response.text())
    .then(res => {
      this.listTarget.innerHTML = res;
    })
  }
}
